const global = {
  // 客服qq
  kfqq: '30666956'
  // 联系电话
  , tel: '0538-5012366'
}

export default global



// WEBPACK FOOTER //
// ./src/utils/Global.js